import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiTruck } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const GoodsReceiptsMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (
      !(
        (user.roles_names.includes("View Good Receipt Invoice") &&
          !user.roles_names.includes("Good Receipt Vendor")) ||
        user.roles_names.includes("View Good Receipt Issue")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="goodsReceipts"
          onClick={() => handleClick("goodsReceipts")}
          title={t("menu.goodsReceipts.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiTruck} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.goodsReceipts.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={openSubmenu.goodsReceipts ? mdiChevronUp : mdiChevronDown}
          />
        </ListItemButton>
        <Collapse in={openSubmenu.goodsReceipts} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {user.roles_names.includes("View Good Receipt Invoice") &&
              !user.roles_names.includes("Good Receipt Vendor") && (
                <HybridRouteListItemButtonLink
                  caption="good receipts invoices"
                  isReact={false}
                  name="goodsReceipts[invoices]"
                  sx={{ pl: 4 }}
                  title={t("menu.goodsReceipts.submenu.invoices.title")}
                  url="/vbuyer/goods_receipts"
                >
                  <ListItemText
                    primary={t("menu.goodsReceipts.submenu.invoices.title")}
                    slotProps={{
                      primary: { sx: { fontSize: 14 } },
                    }}
                    sx={{ whiteSpace: "normal" }}
                  />
                </HybridRouteListItemButtonLink>
              )}

            {user.roles_names.includes("View Good Receipt Issue") && (
              <HybridRouteListItemButtonLink
                caption="good receipts issues"
                isReact={false}
                name="goodsReceipts[issues]"
                sx={{ pl: 4 }}
                title={t("menu.goodsReceipts.submenu.issues.title")}
                url="/vbuyer/human_tasks/good_receipt_validation"
              >
                <ListItemText
                  primary={t("menu.goodsReceipts.submenu.issues.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
